import React from 'react'
import { Link } from 'react-router-dom'
import styled, { FlattenSimpleInterpolation } from 'styled-components'
import { saleAlternativeColor } from 'uiComponents/constants/colors'
import { fsXXXXL, fwBold } from 'uiComponents/constants/typography'
import { mediaMaxL, mediaMinL } from '../../constants/customMedia'

export type AssetImageType = {
  src: string
  alt?: string
  label?: string
  customStyles?: FlattenSimpleInterpolation
  to: string
}

interface IAssetGridProps {
  assetList: AssetImageType[]
}

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 100%;
`

const LinkedAssetContainer = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${mediaMaxL} {
    width: 50%;
  }

  @media ${mediaMinL} {
    width: 33.33%;
  }
`

const LabelContainer = styled.div`
  position: absolute;
  z-index: 2;
  font-size: ${fsXXXXL}px;
  ${fwBold};
  color: ${saleAlternativeColor};
  pointer-events: none;
`

const AssetImage = styled.img<{ customStyles?: FlattenSimpleInterpolation }>`
  ${({ customStyles }) => customStyles && customStyles}
`

const ImageGrid: React.FC<IAssetGridProps> = ({ assetList }) => {
  return (
    <GridContainer>
      {assetList.map(({ to, label, ...asset }, index) => {
        return (
          <LinkedAssetContainer to={to} key={index}>
            <LabelContainer>{label}</LabelContainer>
            <AssetImage
              src={asset.src}
              alt={asset.alt}
              customStyles={asset.customStyles}
            />
          </LinkedAssetContainer>
        )
      })}
    </GridContainer>
  )
}

export default ImageGrid
